module.exports = __webpack_public_path__ + "img/step1.13764e3c.png";